module.exports = __webpack_public_path__ + "static/media/mobile2.9514d56f.png";